import type { ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useDeleteShopLocation(shop: ShopDto) {
	return useApiMutation(
		"delete",
		"/shops/{shopId}/locations/{shopLocationId}",
		{
			invalidate: useInvalidateShop(shop.id),
			mapVariables: (shopLocationId: string) => ({
				params: { path: { shopId: shop.id, shopLocationId } },
			}),
		},
	);
}
